import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {CurrencyFormatter} from "../../../utils/formatters";
import Confirm from "../../form/Confirm";
import {deleteComponent} from "../../../utils/components";
import {list} from "../../../utils/array";

class TicketPriceList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        props.filter = list(props.filter);
        let columns = {
            "price": {
                header: 'Ár (fejenként)',
                width: 3,
                sortable,
                filterable,
                className: 'currency',
                renderer: CurrencyFormatter,
            },
            "group_price": {
                header: 'Csoportos ár',
                width: 3,
                sortable,
                filterable,
                className: 'currency',
                renderer: CurrencyFormatter,
            },
            "advance_payment_price": {
                header: 'Előleg összege',
                width: 2,
                sortable,
                filterable,
                className: 'currency',
                renderer: CurrencyFormatter,
            },
            "limit": {
                header: 'Fő felett',
                width: 3,
                sortable,
                filterable
            },
        };
        if (this.props.groupPrices !== undefined) {
            columns = {
                actions: {
                    header: this.props.actions,
                    width: 'cell-button',
                    renderer: (v, rowData) => <Confirm
                        header="Törlés"
                        body="Biztosan törlöd ezt a tételt?"
                        acceptButton="Törlés"
                        color="danger"
                        timeout={3}
                        icon={{lib: "fa", name: "trash"}}
                        buttonSize="xs"
                        onAccept={async () => {
                            await deleteComponent(props.componentConfig.componentname, {[componentConfig.idfield]: rowData[componentConfig.idfield]});
                            this.list && this.list.refresh();
                        }}
                    />
                },
                ...columns
            };
            if (this.props.groupPrices) {
                props.filter.push({
                    field: "group_price",
                    operator: "not isnull"
                });
                delete columns['price'];
                columns.group_price.width = 7;
            } else {
                props.filter.push({
                    field: "group_price",
                    operator: "isnull"
                });
                delete columns['group_price'];
                columns.price.width = 7;
            }
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : (this.props.groupPrices !== undefined ? (this.props.groupPrices ? "TicketPriceListGroup" : "TicketPriceListSingle") : "TicketPriceList")}
                {...props}
                columns={columns}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default TicketPriceList;
